import { BUCKET_BY_TYPES, EXPERIMENT_PROJECTS } from '@lusha/experiment-react-sdk';
const FLAGS = {
    // PLUGIN_BULK_FILTERS_TEST: {
    //   key: 'plugin_bulk_filters_test',
    //   project: EXPERIMENT_PROJECTS.PLUGIN,
    //   bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
    //   variations: {
    //     CONTROL: 'control_filters',
    //     TEST: 'test_bulk_dropdown_filters',
    //   },
    // },
    PLUGIN_ON_DEMAND_CONTACTS: {
        key: 'on_demand_test',
        project: EXPERIMENT_PROJECTS.PLUGIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        variations: {
            CONTROL: 'on_demand_control_variant',
            TEST: 'on_demand_test_variant',
        },
    },
    AI_ASSISTANT: {
        enabled: true,
        preload: { enrolledOnly: true },
        project: EXPERIMENT_PROJECTS.MAIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        key: 'ai_assistant_m2',
        variations: {
            TEST: 'test_homepage_with_assistant',
            CONTROL: 'control_homepage_with_search',
        },
    },
    AUTO_OPEN_DEFAULT: {
        enabled: true,
        preload: { enrolledOnly: true },
        project: EXPERIMENT_PROJECTS.MAIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        key: 'plugin_auto_open_setting_off_by_default',
        variations: {
            TEST: 'test_auto_open_off_default',
            CONTROL: 'test_auto_open_on_default',
        },
    },
    PLUGIN_UPGRADE_FLOW: {
        enabled: true,
        preload: { enrolledOnly: true },
        project: EXPERIMENT_PROJECTS.PLUGIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        key: 'plugin_upgrade_from_free_to_paid',
        variations: {
            TEST: 'test_upgrade_pop_up_shown',
            CONTROL: 'control_dashboard_pricing_page_redirect',
        },
    },
};
const FLAG_SETTINGS = [
    // {
    //   key: FLAGS.PLUGIN_BULK_FILTERS_TEST.key,
    //   project: EXPERIMENT_PROJECTS.PLUGIN,
    //   preload: { disableImpression: true },
    //   enabled: true,
    //   bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
    // },
    {
        key: FLAGS.PLUGIN_ON_DEMAND_CONTACTS.key,
        project: EXPERIMENT_PROJECTS.PLUGIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        preload: false,
    },
    {
        key: FLAGS.AI_ASSISTANT.key,
        project: EXPERIMENT_PROJECTS.MAIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        preload: true,
    },
    {
        key: FLAGS.AUTO_OPEN_DEFAULT.key,
        project: EXPERIMENT_PROJECTS.PLUGIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        preload: false,
    },
    {
        key: FLAGS.PLUGIN_UPGRADE_FLOW.key,
        project: EXPERIMENT_PROJECTS.PLUGIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        preload: false,
    },
];
export { FLAG_SETTINGS, FLAGS };
